import { useContext } from "react";
import Language from "../language/language.component";
import { BurgerMenuContainer,  BurgerMenuWrapper ,BurgerItemsWrapper, MobileNavigationContainer, MobileNavigationWrapper, BurgerItemsContainer, } from "./mobile-navigation.styles";
import { Link } from "react-scroll";
import { LogoImg } from "../navigation/navigation.styles";
import { CartContext } from "../../contexts/cart.context";
import { Phone, SocialLinks } from "../navigation/navigation.styles";
import phone from '../../assets/icons/phone.svg'
import telegram from '../../assets/icons/telegram.svg';
import whatsap from '../../assets/icons/whatsapp.svg';
import viber from '../../assets/icons/viber.svg';
import Logo  from '../../assets/logo/logo.png';

const setHash = (id) => {
	window.history.replaceState(null, "", `${window.location.pathname}#${id}`);
};

const MobileNavigation =({props})=>{
	const {isCartOpen, setIsCartOpen} = useContext(CartContext);
	return(
		<MobileNavigationWrapper>
			<MobileNavigationContainer>
				<BurgerMenuWrapper onClick={()=> setIsCartOpen(!isCartOpen)}>
					<BurgerMenuContainer className={isCartOpen && 'active'}>
						<button type="button" className="nav-toggler">
							<span></span>
						</button>
					</BurgerMenuContainer>
				</BurgerMenuWrapper>


				<Link className='logoContainer logo' to="home" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHash("home")}>
					<LogoImg src={Logo} alt='main-logo' />
				</Link>
				<Language/>

				{
					isCartOpen &&
				<BurgerItemsWrapper>
					<BurgerItemsContainer>
						<li><Link to="why-us" spy={true} smooth={true} offset={-150} duration={500} onClick={()=> { setHash("why-us"); setIsCartOpen(!isCartOpen); }}>{props[1]}</Link></li>
						<li><Link to="about-us" spy={true} smooth={true} offset={-150} duration={500} onClick={()=> { setHash("about-us"); setIsCartOpen(!isCartOpen); }}>{props[2]}</Link></li>
						<li><Link to="services" spy={true} smooth={true} offset={-150} duration={500} onClick={()=> { setHash("services"); setIsCartOpen(!isCartOpen); }} >{props[3]}</Link></li>
						<li><Link to="contacts" spy={true} smooth={true} offset={0} duration={500} onClick={()=> { setHash("contacts"); setIsCartOpen(!isCartOpen); }}>{props[4]}</Link></li>
						<li>
							<Phone className="phone">
								<a href="tel:+37369107497">
									<img src={phone} alt="" />
									<span>069 107 497</span> 
								</a>
							</Phone>
						</li>
						<li>
							<SocialLinks className="socialLinks">
								<div>
								<a href="https://telegram.me/+37369107497" className='telega'><span><img src={telegram} alt="" /></span></a>
								<a href="https://wa.me/+37369107497"><span className='whatsap'><img src={whatsap} alt="" /></span></a>
								<a href="viber://chat?number=%2B37369107497" ><span className='viber'><img src={viber} alt="" /></span></a>
								</div>
							</SocialLinks>
						</li>
					</BurgerItemsContainer>
					{/* <div className="background"></div> */}
				</BurgerItemsWrapper>
				}
			</MobileNavigationContainer>
		</MobileNavigationWrapper>
	)
}

export default MobileNavigation;